<template>
  <v-container class="fill-height pa-0 align-start">
    <v-row class="" dense>
      <v-col cols="12">
        <navTabs />
      </v-col>
      <router-view />
    </v-row>
  </v-container>
</template>

<script>
import navTabs from '@/components/common/ui/navTabs.vue'
export default {
  components: {
    navTabs
  },
  data () {
    return {

    }
  },
  methods: {

  }

}
</script>
